export const config = {
  handler: null,
};

/**
 * Closes the child context.
 */
export function close() {
  config.handler.close();
}

/**
 * Sets the message handler.
 *
 * @param {Function} handler
 */
export function onMessage(handler) {
  config.handler.onMessage(handler);
}

/**
 * Opens the child context.
 *
 * @param {String} nameUrl
 * @param  {...any} additional
 * @returns {Promise}
 */
export function open(nameUrl, ...additional) {
  return config.handler.open(nameUrl, ...additional);
}

/**
 * Sends an action + payload to the child context.
 *
 * @param {String} action
 * @param {any} payload
 */
export function sendMessage(action, payload) {
  config.handler.sendMessage(action, payload);
}

/**
 * Sets the app for the child context.
 *
 * @param {Object} app
 */
export function setApp(app) {
  config.handler.setApp(app);
}

/**
 * Sets the configuration.
 *
 * @param {Object} configDetails
 */
export function setConfig(configDetails) {
  config.handler.setConfig(configDetails);
}

/**
 * Sets the error for the child context.
 *
 * @param {String} error
 */
export function setError(error) {
  config.handler.setError(error);
}

/**
 * Sets the client app context handler.
 *
 * @param {Object} handler
 */
export function setHandler(handler) {
  config.handler = handler;
}

/**
 * Sets the loading state for the child context.
 *
 * @param {Boolean} isLoading
 */
export function setLoading(isLoading) {
  config.handler.setLoading(isLoading);
}

/**
 * Sets the saving state for the child context.
 *
 * @param {Boolean} isSaving
 */
export function setSaving(isSaving) {
  config.handler.setSaving(isSaving);
}
